export default __webpack_public_path__ + "static/icon-12-1-9d631b09de36d31fb81120d7ef54ff5f.png";